import React, { useEffect, useState } from 'react'
import { Col, Form, FormGroup, Label, Row } from 'reactstrap';
import Transparentspinner from '../../../Common/Loader/Transparentspinner';
import { Controller, useForm } from 'react-hook-form';
import { City, Country, FirstName, LastName, Save, State } from '../../../../Constant';
import { Btn } from '../../../../AbstractElements';
import PhoneInput from 'react-phone-input-2';
import { toast } from 'react-toastify';
import { postClientUrlWithToken } from '../../../../Utils/restUtils';
import { updateMasterProfile } from '../../../../CommonUrl';
import { useSelector } from 'react-redux';


const EditProfile = (props) => {
    const e = props.personalinfo;
    const [loading, setLoading] = useState(false);
    const authState = useSelector((state) => state.auth);
    const { register, handleSubmit, control, formState: { errors }, setValue } = useForm();

    useEffect(() => {
        handleEditView();
    }, []);

    const handleEditView = () => {
        setValue("fname", e.first_name);
        setValue("lname", e.last_name);
        setValue("country", e.country);
        setValue("state", e.state);
        setValue("city", e.city);
    }
    const onSubmit = async (data) => {
        setLoading(true);
        const postRequest = {
            first_name: data.fname,
            last_name: data.lname,
            country: data.country,
            state: data.state,
            city: data.city,
        };
        const editPersonalInfo = await postClientUrlWithToken(authState.apiUrl, updateMasterProfile, postRequest);
        if (editPersonalInfo.data.status) {
            toast.success(editPersonalInfo.data.message);
        } else {
            setLoading(false);
            toast.error(editPersonalInfo.data.message);
        }
        setLoading(false);
    }

    return (
        <>
            {loading && <Transparentspinner />}
            <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <Row className="pt-3">
                    <Col md="6">
                        <Label className="form-label" for="first_name">
                            {FirstName}
                        </Label>
                        <input className="form-control" id="first_name" type="text" {...register("fname")} />
                        {/* <p className="text-danger">{errors.fname?.message}</p> */}
                    </Col>
                    <Col md="6">
                        <Label className="form-label" for="last_name">
                            {LastName}
                        </Label>
                        <input className="form-control" id="last_name" type="text" {...register("lname")} />
                        {/* <p className="text-danger">{errors.lname?.message}</p> */}
                    </Col>
                </Row>
                <Row className=" pt-3">
                    <Col md="6">
                        <Label className="form-label" for="last_name">
                            {Country}
                        </Label>
                        <input className="form-control" id="country" type="text" {...register("country")} />
                        {/* <p className="text-danger">{errors.lname?.message}</p> */}
                    </Col>
                    <Col md="6">
                        <Label className="form-label" for="state">
                            {State}
                        </Label>
                        <input className="form-control" id="state" type="text" {...register("state")} />
                        {/* <p className="text-danger">{errors.fname?.message}</p> */}
                    </Col>
                </Row>
                <Row className="g-3 pt-3">
                    <Col md="6">
                        <Label className="form-label" for="last_name">
                            {City}
                        </Label>
                        <input className="form-control" id="city" type="text" {...register("city")} />
                        {/* <p className="text-danger">{errors.lname?.message}</p> */}
                    </Col>
                </Row>
                <FormGroup></FormGroup>
                <Btn attrBtn={{ color: "primary" }} type="submit">
                    {Save}
                </Btn>
            </Form>
        </>
    )
}

export default EditProfile